import { Injectable } from '@angular/core';
import { Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WebService } from '../web.service';

@Injectable()
export class RecruitmentService extends WebService {

    public getRecruitment (page?: number, per_page?: number, sort?: string, query?: string, filters?: any[]): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        if (page !== null && page !== undefined) {
            params.append('_page', String(page));
        } else {
            params.append('_page', '1');
        }

        if (per_page !== null && per_page !== undefined) {
            params.append('_limit', String(per_page));
        } else {
            params.append('_limit', '10');
        }

        if (sort !== null && sort !== undefined) {
            params.append('_sort', String(sort));
        }

        if (query !== null && query !== undefined && query !== '') {
            params.append('_q', String(query));
        }

        if (filters !== null && filters !== undefined && filters.length > 0) {
            filters.forEach(element => {
                params.append(element.key, String(element.value));
            });
        }

        params.append('_with', String('requisition.employee,company,venue,profile_survey.checklist_profile_survey.list_doc_profile_survey,recruited_by,' +
        'candidate.education,candidate.work_experience,candidate.citation.company,candidate.citation.profile_survey,' +
        'candidate.citation.venue,candidate.candidate_comment'));

        const options = new RequestOptions({search: params, headers: this.headers});
        

        return this.http.get( `${this.apiUrl}/recruitments?${params}`, options);
    }

    public getRecruitmentRequisition (id: number,
        page?: number, per_page?: number, sort?: string, query?: string,
        filters?: any[]): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        if (page !== null && page !== undefined) {
            params.append('_page', String(page));
        } else {
            params.append('_page', '1');
        }

        if (per_page !== null && per_page !== undefined) {
            params.append('_limit', String(per_page));
        } else {
            params.append('_limit', '10');
        }

        if (sort !== null && sort !== undefined) {
            params.append('_sort', String(sort));
        }

        if (query !== null && query !== undefined && query !== '') {
            params.append('_q', String(query));
        }

        if (filters !== null && filters !== undefined && filters.length > 0) {
            filters.forEach(element => {
                params.append(element.key, String(element.value));
            });
        }

        params.append('_with', String('requisition.employee,company,venue,profile_survey.checklist_profile_survey.list_doc_profile_survey,recruited_by,' +
        'candidate.education,candidate.work_experience,candidate.citation.company,candidate.citation.profile_survey,' +
        'candidate.citation.venue,candidate.candidate_comment'));
        
        const options = new RequestOptions({search: params, headers: this.headers});
        

        return this.http.get( `${this.apiUrl}/recruitments?${params}`, options);
    }

    public getRecruitmentByRequisition (id: number,
        page?: number, per_page?: number, sort?: string, query?: string,
        filters?: any[]): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        if (page !== null && page !== undefined) {
            params.append('_page', String(page));
        } else {
            params.append('_page', '1');
        }

        if (per_page !== null && per_page !== undefined) {
            params.append('_limit', String(per_page));
        } else {
            params.append('_limit', '10');
        }

        if (sort !== null && sort !== undefined) {
            params.append('_sort', String(sort));
        }

        if (query !== null && query !== undefined && query !== '') {
            params.append('_q', String(query));
        }

        if (filters !== null && filters !== undefined && filters.length > 0) {
            filters.forEach(element => {
                params.append(element.key, String(element.value));
            });
        }

        params.append('_with', String('requisition.employee,company,venue,profile_survey.checklist_profile_survey.list_doc_profile_survey,recruited_by,' +
        'candidate.education,candidate.work_experience,candidate.citation.company,candidate.citation.profile_survey,' +
        'candidate.citation.venue,candidate.candidate_comment'));
        
        const options = new RequestOptions({search: params, headers: this.headers});
        

        return this.http.get( `${this.apiUrl}/requisitions/${id}/citations?${params}`, options);
    }

    public newRecruitment(body: Object): Observable<Response> {
        return this.http.post( `${this.apiUrl}/citations`, JSON.stringify(body), { headers: this.headers } );
    }

    public updateRecruitment(id: number, body: Object): Observable<Response> {
        return this.http.patch( `${this.apiUrl}/citations/${id}`, JSON.stringify(body) , { headers: this.headers } );
    }

    public deleteRecruitment(id: number): Observable<Response> {
        return this.http.delete( `${this.apiUrl}/citations/${id}`, { headers: this.headers } );
    }

    public infoRecruitment(id: number): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();
        params.append('id', String(id));
        // params.append('_sort', String('-newnesses.created_at'));
        // params.append('_with', String('station,newnesses.user.employee'));

        const options = new RequestOptions({search: params, headers: this.headers});
        

        return this.http.get( `${this.apiUrl}/citations?${params}`,  options );
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/service/recruitment/recruitment.service.ts